import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { MIN_UPDATE_REASON_LENGTH, PvzKeys } from 'sections/LKSection/modules/PvzModule/data'

import { MIN_OPENING_HOURS, MIN_WORKING_DAYS } from '../../data'
import { TimetableModel } from '../../models/TimetableModel/TimetableModel'

export class ValidateTimetable extends ValidateFormService {
  validate = (uiStore: TimetableModel, returnType: 'boolean' | 'array' = 'boolean', isOrder: boolean = true) => {
    const errors: string[] = []
    let numberOfWorkingDays = 0

    const getKey = (key: string) => `${OrderKeys.workConditionsStep}.validate.${key}`

    uiStore.weekDays.forEach((day) => {
      if (!day.isDayOff) {
        numberOfWorkingDays++
      }
    })

    if (numberOfWorkingDays < MIN_WORKING_DAYS) {
      errors.push(i18next.t(getKey('numberOfWorkingDays'), { count: MIN_WORKING_DAYS }))
    }

    if (uiStore.invalidOpeningHours) {
      errors.push(i18next.t(getKey('invalidOpeningHours'), { count: MIN_OPENING_HOURS }))
    }

    if (!isOrder && uiStore.timetableUpdateReason.trim().length < MIN_UPDATE_REASON_LENGTH) {
      errors.push(
        i18next.t(`${PvzKeys.editTimetablePage}.validate.timetableUpdateReasonMinLength`, {
          count: MIN_UPDATE_REASON_LENGTH,
        }),
      )
    }

    return returnType === 'boolean' ? this.hasNotErrors(errors) : errors
  }
}

export const validateTimetable = new ValidateTimetable()
